import React, { useState, useEffect } from 'react';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';

import { getRolesList } from '../../../slices/thunks';

const RolesSelect = ({ value, onChange, onBlur, invalid, error, onSelect }) => {
	const dispatch = useDispatch();

	const selectRolesList = createSelector(
		state => state.Roles.roleListSelect,
		roleListSelect => roleListSelect
	);

	const roleListSelect = useSelector(selectRolesList);

	const [selectedVisibility, setselectedVisibility] = useState('');

	function getValueFromListSelector(value) {
		let valueSelector;
		roleListSelect.map(item => {
			if (item.item._id === value) {
				valueSelector = item;
			}
		});
		return valueSelector;
	}

	function handleSelectVisibility(optionSelected) {
		setselectedVisibility(optionSelected);
		onSelect(optionSelected);
		invalid = false;
		error = null;
	}

	useEffect(() => {
		if (roleListSelect.length === 0) {
			dispatch(getRolesList());
		}
	}, []);

	useEffect(() => {
		const itemListSelected = getValueFromListSelector(value._id);
		handleSelectVisibility(itemListSelected || '');
	}, [roleListSelect]);

	const selectStyle = {
		border: invalid ? '1px solid red' : '1px solid #ccc',
	};

	const selectClassName = invalid ? 'select-is-invalid' : '';

	return (
		<>
			<label htmlFor='role-field' className='form-label'>
				Perfil de Usuario
			</label>

			<Select
				value={selectedVisibility}
				options={roleListSelect}
				onChange={e => {
					handleSelectVisibility(e);
				}}
				name='role'
				id='role-field'
				classNamePrefix='select2-selection form-select'
				className={`${selectClassName}`}
				placeholder='Seleccione una opción'
				style={selectStyle}
			/>
			{/* {invalid && <div className="invalid-feedback">{error}</div>} */}

			{invalid && !selectedVisibility ? (
				<div className='invalid-feedback'>{error}</div>
			) : null}
		</>
	);
};

export default RolesSelect;
